import { render, staticRenderFns } from "./CreateCustomerUploadForm.vue?vue&type=template&id=b228e480&scoped=true&"
import script from "./CreateCustomerUploadForm.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b228e480",
  null
  
)

export default component.exports